export const ENROLLED_IN_CREDIT = 'ENROLLED_IN_CREDIT';

export const enrolledInCredit = () => dispatch =>
  dispatch({
    type: ENROLLED_IN_CREDIT,
  });
